import React, { useState, useEffect } from 'react';

const getSafeData = (data: any): any[] => {
  return Array.isArray(data) ? data : [];
};

export default function useDataExtend(props: {
  data: any;
  chartsInstances: React.MutableRefObject<any[]>;
}) {
  const { data: dataOriginal, chartsInstances } = props;

  const [data, setData] = useState(getSafeData(dataOriginal));

  const updateSerieStyle = (getItemStyle: (serie: any) => { [key: string]: any }) => {
    if (!Array.isArray(data)) return;
    if (!Array.isArray(chartsInstances?.current)) return;
    const dataTmp = data.map((item: any, idx: number) => {
      const chartInstance = chartsInstances?.current?.[idx];
      const optionsTmp = chartInstance?.getOption() || item?.options || {};
      const seriesTmp = optionsTmp?.series?.map((serie: any) => {
        return {
          ...serie,
          itemStyle: {
            ...serie?.itemStyle,
            ...getItemStyle(serie),
          },
        };
      }) || [];

      return {
        ...item,
        options: {
          ...optionsTmp,
          series: seriesTmp,
        },
      };
    });
    setData(dataTmp);
  };

  const handleHighlight = (payload: any) => {
    updateSerieStyle((serie: any) => {
      return {
        opacity: payload?.name === serie?.name ? 1 : 0.3,
      };
    });
  };

  const handleDownplay = () => {
    updateSerieStyle(() => {
      return {
        opacity: 1,
      };
    });
  };

  useEffect(() => {
    setData(getSafeData(dataOriginal));
  }, [dataOriginal]);

  return {
    data,
    onHighlight: handleHighlight,
    onDownplay: handleDownplay,
  };
}
